import React from "react";
import { MapPin } from "lucide-react";
import SmartImage from "@/components/SmartImage";

/**
 * Community Celebration Gallery card — pure image tile.
 * Video playback + Submit-Video flow removed per pre-launch product direction;
 * this component keeps the same name and props so nothing else has to change,
 * but renders a static thumbnail with title, category, and location only.
 */
export default function VideoCard({ video, featured = false, priority = false }) {
    return (
        <article
            className={`relative rounded-sm overflow-hidden bg-[#0F162A] border border-white/10 ${featured ? "" : "transition-transform duration-300 hover:-translate-y-1"}`}
            data-testid={`video-card-${video.id}`}
        >
            <div className={`relative ${featured ? "aspect-[16/9]" : "aspect-video"} bg-[#0A1128]`}>
                {video.thumbnail_url ? (
                    <SmartImage
                        src={video.thumbnail_url}
                        alt={video.title}
                        className="absolute inset-0 w-full h-full"
                        imgClassName="opacity-95"
                        priority={featured || priority}
                    />
                ) : (
                    <div className="w-full h-full stars-bg bg-[#0A1128]" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128]/95 via-[#0A1128]/25 to-transparent pointer-events-none" />
                {video.featured && (
                    <span className="absolute top-3 left-3 px-2 py-1 text-[10px] uppercase tracking-widest bg-[#9B1B30] text-white rounded-sm">Featured</span>
                )}
                {video.sponsor_tag && (
                    <span className="absolute top-3 right-3 px-2 py-1 text-[10px] uppercase tracking-widest bg-[#D4AF37] text-[#0A1128] rounded-sm">Sponsor</span>
                )}
            </div>
            <div className="p-4">
                <div className="text-[10px] uppercase tracking-widest text-[#D4AF37] mb-1">{video.category}</div>
                <h3 className="font-heading text-lg text-white line-clamp-2 leading-snug">{video.title}</h3>
                <div className="mt-2 flex items-center gap-2 text-xs text-white/60">
                    <MapPin className="w-3 h-3" />
                    <span>{video.city}, {video.state}</span>
                </div>
            </div>
        </article>
    );
}
